// AppKeyContext.tsx
import React, { createContext, useContext } from 'react';

export const AppKeyContext = createContext<{
  refreshApp: () => void;
} | null>(null);

export const useAppKey = () => {
  const context = useContext(AppKeyContext);
  if (!context) throw new Error("useAppKey must be used within AppKeyProvider");
  return context;
};
